<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="经销商:">
              <el-input v-model.trim="formInlineTmp.dealer" placeholder="请输入经销商名称" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="银行卡号:">
              <el-input v-model.trim="formInlineTmp.card_code" placeholder="请输入银行卡号" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="formInlineTmp.status" placeholder="请选择">
                <el-option v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="getCashoutsetAction(0)" class="add-btn btn-right" style="float: right;">提现设置</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <el-table-column label="经销商">
          <template slot-scope="scope">
            {{ scope.row.dealer_name }}
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            {{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column label="银行">
          <template slot-scope="scope">
            {{ scope.row.bank_name }}
          </template>
        </el-table-column>
        <el-table-column label="卡号">
          <template slot-scope="scope">
            {{ scope.row.card_code }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if=" scope.row.status === 1" style="color:blue">未审核</span>
            <span v-if=" scope.row.status === 2" style="color:green">通过审核</span>
            <span v-if=" scope.row.status === 3" style="color:darkred">未通过审核</span>
          </template>
        </el-table-column>
        <el-table-column label="审核时间">
          <template slot-scope="scope">
            <span v-if=" scope.row.status !== 1">{{ scope.row.examine_time_text }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 1" class="op-link" @click="editAction(scope.row.id, 2)">
              通过审核
            </div>
            <div v-if="scope.row.status === 1" class="op-link" @click="editAction(scope.row.id, 3)">
              不通过审核
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog class="cellDialog base-dialog base-dialog-set" title="提现设置" :visible.sync="cashoutsetDialog" width="550px">
        <el-form :model="cashoutsetForm" label-width="110px" ref="cashoutsetForm" >
          <el-form-item label="是否开启：" prop="isopen" style="text-align: left">
            <el-switch v-model="cashoutsetForm.isopen" active-value='1' inactive-value='0'>
            </el-switch>
          </el-form-item>
          <el-form-item label="提现时间：" prop="start" style="text-align: left">
            <el-row>
              <el-col :span="3"><div>每月</div></el-col>
              <el-col :span="6"><el-input v-model="cashoutsetForm.start" placeholder="1" type="number" min="1" style="width: 89px!important;"></el-input></el-col>
              <el-col :span="2"><div style="text-align: center;">至</div></el-col>
              <el-col :span="6"><el-input v-model="cashoutsetForm.end" placeholder="31" type="number" max="31" style="width: 89px;"></el-input></el-col>
              <el-col :span="2"><div style="margin-left: 8px;">号</div></el-col>
            </el-row>
            <p>不设置默认整个月都可以提现。</p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="closeDialogAction">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('cashoutsetForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { getYxAccountList, approveYxAccountApprove, getYxCashoutsetDetail, editYxCashoutset } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      formInlineTmp:{},
      formInline: {
        title:'',
      },
      options: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '审核中'
        },
        {
          value: '2',
          label: '通过'
        },
        {
          value: '3',
          label: '失败'
        },
      ],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      cashoutsetDialog:false,
      isopen: 1,
      cashoutsetForm: {
        id: 0,
        isopen: '1',
        start: 1,
        end: 31
      }
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYxAccountList(this.page, this.limit, 1, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    editAction(id, status) {
      let str = '审核通过'
      if(status == 2){
        str = '[通过审核]'
      }
      else if(status == 3){
        str = '[不通过审核]'
      }
      else{
        return
      }
      this.$confirm('确认此信息' + str + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        approveYxAccountApprove(id, status).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '操作成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 请求提现设置
    getCashoutsetAction(id) {
      this.cashoutsetDialog = true
      getYxCashoutsetDetail(id).then(res => {
        if(res.data.code === 0){
          this.cashoutsetForm = res.data.data
        }
        else{
          this.editForm = {
            id: 0,
            isopen: '1',
            start: 1,
            end: 31
          }
        }
      })
    },
    //提现设置
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.cashoutsetAction()
        } else {
          return false
        }
      })
    },
    cashoutsetAction() {
      editYxCashoutset(this.cashoutsetForm.id, this.cashoutsetForm).then(res => {
        if (res.data.code === 0) {
          this.cashoutsetDialog = false
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    closeDialogAction() {
      this.cashoutsetDialog = false
    },
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.el-input__inner{
  width: 89px!important;
}
</style>
